import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import IconButton from '@material-ui/core/IconButton'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import CustomButton, {
  // LongCustomButton,
  CancelCustomButton
} from '../custom-material/button/Button'
import { DenseCustomCheckbox } from '../custom-material/checkbox/Checkbox'
import CustomFormControlLabel from '../custom-material/form-control-label/FormControlLabel'
import CustomTypography from '../custom-material/typography/Typography'
import DeleteIcon from '@material-ui/icons/Delete'
import HelpIcon from '@material-ui/icons/Help'
import {
  checkProductActive,
  checkProductPurchased,
  determineProductGroups,
  determineProducts,
  determineRegions,
  lookupLabel
} from '../../libs/utils'
import { isEmpty, range, uniq } from 'lodash'
import AddUsersDialogComponent from './AddUsersDialogComponent'
import BulkAddUsersComponent from './BulkAddUsersComponent'
import { contactValidState, isValidContact } from '../../libs/validators'

const styles = theme => ({
  addUsersCard: {
    margin: 16
  },
  addUsersCardHeader: {
    backgroundColor: '#e1ecf8'
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 22
  },
  howManyText: {
    color: '#003368',
    fontWeight: 600,
    fontSize: 14
  },
  howManyHr: {
    border: '1px solid #003368',
    margin: '16px 0'
  },
  howManySelect: {
    width: 65
  },
  addUsersLabel: {
    color: '#003368',
    fontWeight: 600,
    fontSize: 18
  },
  addUsersInput: {
    fontSize: 15,
    outline: '1px solid rgba(0, 0, 0, 0.42)',
    marginTop: '18px !important'
  },
  addUsersInputText: {
    overflow: 'hidden',
    paddingLeft: 3,
    paddingRight: 3
  },
  addUsersInputDisabled: {
    color: 'rgb(84, 84, 84)',
    cursor: 'text',
    fontSize: 15,
    border: 0,
    paddingLeft: 0
  },
  addUsersCardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 24px 16px 24px',
  },
  subscriptionAccess: {
    display: 'flex'
  },
  subscriptionAccessHelp: {
    marginLeft: 4,
    fontSize: 22,
    color: '#00ACEF'
  },
  productGroupName: {
    marginBottom: 6
  },
  productGroupProduct: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 6
  },
  formControlLabel: {
    marginLeft: 6
  },
  checkboxIcon: {
    width: 20,
    height: 20
  },
  selectInputBase: {
    outline: '1px solid rgba(0, 0, 0, 0.42)',
    marginTop: '18px !important'
  },
  selectInputBaseHowMany: {
    outline: '1px solid rgba(0, 0, 0, 0.42)',
    marginTop: '8px !important'
  },
  selectInputRoot: {
    fontSize: 15,
    height: 30
  },
  selectInput: {
    paddingLeft: 3
  },
  selectMenu: {
    paddingLeft: 3,
    height: 16,
    display: 'flex',
    alignItems: 'center'
  },
  selectMenuItem: {
    fontSize: 15
  },
  tooltip: {
    opacity: '1.0 !important'
  },
  deleteIcon: {
    color: '#e52b2b'
  },
  validationErrorsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 16,
    padding: '16px 24px'
  },
  errorText: {
    color: '#f44336'
  }
})

class AddUsersComponent extends React.PureComponent {
  render () {
    const { classes, contactsToAdd, companies, addMoreUsers, updateContactValue, updateContactSubscription, isBulkAdd } = this.props
    const { addContacts, dialogOpen, resetContactsToAdd, removeContactToAdd, closeDialog } = this.props
    const invalidContacts = ((contactsToAdd || []).map((c) => {
      if (!isValidContact(c)) {
        return contactValidState(c)
      }
      return null
    }) || []).filter((c) => !!c)
    let validationErrorMessages = []
    for (const c of invalidContacts) {
      delete c['isValid']
      delete c['company']
      for (const [key, value] of Object.entries(c)) {
        validationErrorMessages = [...validationErrorMessages, `${lookupLabel(key)} is ${value}`]
      }
    }
    validationErrorMessages = uniq(validationErrorMessages)
    const validationErrorMessage = validationErrorMessages.join('; ')
    const noCompaniesDataError = !companies || isEmpty(companies)
    const noSubscriptionDataError = (contactsToAdd || []).some((x) => !x.subscription || isEmpty(x.subscription) || !x.subscription.productGroups || isEmpty(x.subscription.productGroups))

    return (
      <Card className={classes.addUsersCard}>
        <CardHeader className={classes.addUsersCardHeader} title={<div className={classes.title}><span>Add Users</span></div>} />
        <CardContent>
          {isEmpty(contactsToAdd) || isBulkAdd
            ? null // @TODO - empty state
            : <React.Fragment>
              <CustomTypography className={classes.howManyText}>How many users would you like to add?</CustomTypography>
              <FormControl className={classes.howManySelect} required>
                <Select
                  className={classes.selectInputBaseHowMany}
                  required
                  value={contactsToAdd.length || 1}
                  onChange={addMoreUsers}
                  MenuProps={{classes: {paper: classes.selectMenuPaper}}}
                  classes={{selectMenu: classes.selectMenu}}
                  disableUnderline
                  inputProps={{
                    name: 'howManyUsers',
                    id: 'how-many-users',
                    classes: {
                      root: classes.selectInputRoot
                    }
                  }}
                  // error={}
                >
                  {[...range(15)].map(x => x + 1).map((x, i) => (
                    <MenuItem className={classes.selectMenuItem} key={i} value={x}>{x}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <hr className={classes.howManyHr} />
              {contactsToAdd.map((contact, contactIndex) => {
                const validState = contactValidState(contact)

                return (
                  <React.Fragment key={contactIndex}>
                    <Grid container className={classes.addUsersGrid} spacing={2}>
                      <Grid item xs={10}>
                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <TextField
                              id='firstName'
                              label='First Name:'
                              required
                              value={contact.firstName}
                              InputProps={{disableUnderline: true, tabIndex: 1, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.firstName}
                              onChange={updateContactValue(contactIndex, 'firstName')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='lastName'
                              label='Last Name:'
                              required
                              value={contact.lastName}
                              InputProps={{disableUnderline: true, tabIndex: 2, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.lastName}
                              onChange={updateContactValue(contactIndex, 'lastName')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='emailAddress'
                              label='Email:'
                              required
                              value={contact.emailAddress}
                              InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.emailAddress}
                              onChange={updateContactValue(contactIndex, 'emailAddress')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl required fullWidth error={!!validState.company}>
                              <InputLabel shrink classes={{shrink: classes.addUsersLabel}} htmlFor='company-select'>Company</InputLabel>
                              <Select
                                className={classes.selectInputBase}
                                required
                                value={contact.company || companies[0] || ''}
                                onChange={updateContactValue(contactIndex, 'company')}
                                MenuProps={{classes: {paper: classes.selectMenuPaper}}}
                                classes={{selectMenu: classes.selectMenu}}
                                disableUnderline
                                inputProps={{
                                  name: 'company',
                                  id: 'company-select',
                                  classes: {
                                    root: classes.selectInputRoot
                                  }
                                }}
                                displayEmpty
                                error={!!validState.company}
                              >
                                {isEmpty(companies) ? <MenuItem value='' disabled>No Companies Found</MenuItem> : null}
                                {companies.map((company, i) => (
                                  <MenuItem className={classes.selectMenuItem} key={i} value={company}>{company}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='department'
                              label='Department:'
                              required
                              value={contact.department}
                              InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.department}
                              onChange={updateContactValue(contactIndex, 'department')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='jobTitle'
                              label='Job Title:'
                              required
                              value={contact.jobTitle}
                              InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.jobTitle}
                              onChange={updateContactValue(contactIndex, 'jobTitle')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='officePhone'
                              label='Office Phone:'
                              required
                              value={contact.officePhone}
                              InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.officePhone}
                              onChange={updateContactValue(contactIndex, 'officePhone')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='country'
                              label='Country:'
                              required
                              value={contact.country}
                              InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              error={!!validState.country}
                              onChange={updateContactValue(contactIndex, 'country')}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              id='mobilePhone'
                              label={<span>Mobile Phone <small>(for subscriber communications)</small></span>}
                              value={contact.mobilePhone}
                              InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                              InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                              fullWidth
                              onChange={updateContactValue(contactIndex, 'mobilePhone')}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      {contactIndex !== 0
                        ? <Grid item xs={2}><IconButton onClick={removeContactToAdd(contactIndex)}><DeleteIcon className={classes.deleteIcon} /></IconButton></Grid>
                        : <Grid item xs={2}><BulkAddUsersComponent addBulkUsers={this.props.addBulkUsers} emailAddress={this.props.emailAddress} /></Grid>
                      }
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={10}>
                        <TextField
                          id='comments'
                          label='Comments:'
                          value={contact.comments}
                          InputProps={{disableUnderline: true, classes: {root: classes.addUsersInput, input: classes.addUsersInputText, disabled: classes.addUsersInputDisabled}}}
                          InputLabelProps={{shrink: true, classes: {shrink: classes.addUsersLabel}}}
                          fullWidth
                          multiline
                          minRows={2}
                          maxRows={2}
                          onChange={updateContactValue(contactIndex, 'comments')}
                        />
                      </Grid><Grid item xs={2} />
                      <Grid item xs={12}>
                        <CustomTypography className={classes.subscriptionAccess} variant='body1' paragraph>
                          <strong>Subscription Access:</strong>&nbsp;
                          Web Portal Access, Email Alerts, Analyst Consultations (Ask an Analyst)
                          <Tooltip
                            classes={{popper: classes.tooltip}}
                            title='Set up phone consultations, submit information requests, and get quick answers to specific questions by engaging our expert analyst team of former patent litigators, patent searchers, clinical pharmacists, brand and generic forecasters, and PhD scientists using our Ask an Analyst button from anywhere on the platform'
                          >
                            <HelpIcon className={classes.subscriptionAccessHelp} />
                          </Tooltip>
                        </CustomTypography>
                        <CustomTypography variant='body1' paragraph>
                          <strong>
                            <span className={isEmpty(contact.subscription) || isEmpty(contact.subscription.productGroups) ? classes.errorText : ''}>
                              Product Selections: *
                            </span>
                          </strong>
                        </CustomTypography>
                        {isEmpty(contact.subscription) || isEmpty(contact.subscription.productGroups)
                          ? <span>No Products Found</span>
                          : determineProductGroups(contact.subscription.productGroups).map((productGroup, productGroupIndex) =>
                            <React.Fragment key={productGroupIndex}>
                              <CustomTypography className={classes.productGroupName} variant='body1'>{`${(productGroup.name || '').toUpperCase()}:`}</CustomTypography>
                              <div className={classes.productGroupContent}>
                                {isEmpty(productGroup.products)
                                  ? <React.Fragment /> // @TODO - empty state
                                  : determineProducts(productGroup.products).filter(x => checkProductPurchased(x.regions)).map((product, productIndex) =>
                                    <div className={classes.productGroupProduct} key={productIndex}>
                                      <CustomFormControlLabel
                                        label={product.name}
                                        classes={{label: classes.formControlLabel}}
                                        control={
                                          <DenseCustomCheckbox
                                            disableRipple
                                            color='default'
                                            checkedIcon={<img className={classes.checkboxIcon} src='/icons/CheckedBox.svg' alt='checked box' />}
                                            icon={<img className={classes.checkboxIcon} src='/icons/UncheckedBox.svg' alt='unchecked box' />}
                                            checked={checkProductActive(product.regions)}
                                            onChange={updateContactSubscription(contactIndex, productGroup, product)}
                                          />
                                        }
                                      />
                                      {isEmpty(product.regions) || product.regions.length === 1
                                        ? <React.Fragment />
                                        : <React.Fragment>
                                          <CustomTypography style={{marginRight: 6}} variant='body1'>REGION(S):</CustomTypography>
                                          {determineRegions(product.regions).map((region, regionIndex) => {
                                            return region.purchased
                                              ? <CustomFormControlLabel
                                                key={regionIndex}
                                                label={region.name}
                                                classes={{label: classes.formControlLabel}}
                                                control={
                                                  <DenseCustomCheckbox
                                                    disableRipple
                                                    color='default'
                                                    checkedIcon={<img className={classes.checkboxIcon} src='/icons/CheckedBox.svg' alt='checked box' />}
                                                    icon={<img className={classes.checkboxIcon} src='/icons/UncheckedBox.svg' alt='unchecked box' />}
                                                    checked={region.accessStatus !== 'no access'}
                                                    disabled={!region.purchased}
                                                    onChange={updateContactSubscription(contactIndex, productGroup, product, region)}
                                                  />
                                                }
                                              />
                                              : null
                                          })}
                                        </React.Fragment>
                                      }
                                    </div>
                                  )
                                }
                              </div>
                              <br />
                            </React.Fragment>
                          )
                        }
                      </Grid>
                    </Grid>
                  </React.Fragment>
                )
              })}
            </React.Fragment>
          }
        </CardContent>
        <div className={classes.validationErrorsContainer}>
          {noCompaniesDataError || noSubscriptionDataError
            ? <span className={classes.errorText}>
                Error: No {noCompaniesDataError && noSubscriptionDataError
                  ? 'Company or Product' : noCompaniesDataError
                  ? 'Company' : noSubscriptionDataError
                  ? 'Product' : ''
                } data was found. Please contact your IPD Account Manager for assistance with adding users.</span>
            : validationErrorMessage
              ? <span className={classes.errorText}>Invalid User(s): {validationErrorMessage}</span>
              : null
          }
        </div>
        {!isBulkAdd && <CardActions className={classes.addUsersCardFooter}>
          <CancelCustomButton variant='contained' color='default' size='small' onClick={resetContactsToAdd}>Cancel</CancelCustomButton>
          {/* <LongCustomButton onClick={addMoreUsers} variant='contained' color='primary' size='small'>Add More Users</LongCustomButton> */}
          <CustomButton variant='contained' color='secondary' size='small' onClick={addContacts}
            disabled={isBulkAdd || validationErrorMessage}>Submit</CustomButton>
        </CardActions>}
        {dialogOpen
          ? <AddUsersDialogComponent
            dialogOpen={dialogOpen}
            contactsToAdd={contactsToAdd}
            handleCloseDialog={closeDialog}
            handleConfirmDialog={resetContactsToAdd}
            addContacts={addContacts}
            isBulkAdd={isBulkAdd}
          />
          : null
        }
      </Card>
    )
  }
}

AddUsersComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  contactsToAdd: PropTypes.array,
  companies: PropTypes.array,
  addMoreUsers: PropTypes.func.isRequired,
  resetContactsToAdd: PropTypes.func.isRequired,
  removeContactToAdd: PropTypes.func.isRequired,
  updateContactValue: PropTypes.func,
  updateContactSubscription: PropTypes.func,
  addBulkUsers: PropTypes.func.isRequired,
  emailAddress: PropTypes.string.isRequired,
  closeDialog: PropTypes.func.isRequired,
  isBulkAdd: PropTypes.bool
}

export default withStyles(styles)(AddUsersComponent)
